import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import AdminTab from "./AdminTab"

const Admins = props => {
  //meta title
  document.title = "จัดการแอดมินผู้ใช้งาน | " + process.env.REACT_APP_CMS_TITLE

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Admins")}
            breadcrumbItem={props.t("จัดการแอดมินผู้ใช้งาน")}
          />
          {/* Add your admins management content here */}
          <AdminTab />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Admins)
